"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockAnalyticsService = void 0;
class MockAnalyticsService {
  constructor() {
    this.startJourney = jest.fn();
    this.endJourney = jest.fn();
    this._composeTaggingActionEvent = jest.fn();
    this._composeTaggingViewEvent = jest.fn();
    this._composeTaggingActionLinkName = jest.fn();
    this._composeTaggingPageName = jest.fn();
    this.composeTaggingEvents = jest.fn();
    this.getEventsName = jest.fn();
    this.getQuestionnaireEventData = jest.fn();
  }
}
exports.MockAnalyticsService = MockAnalyticsService;